export function DockIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_685_3072)">
                <path d="M19.5 2.25H12V3.75H19.1894L9.21968 13.7197L10.2802 14.7803L20.25 4.81058V12H21.75V4.5C21.75 3.25927 20.7407 2.25 19.5 2.25ZM16.5 19.5C16.5 19.9139 16.1638 20.25 15.75 20.25H4.5C4.08652 20.25 3.75 19.9139 3.75 19.5V8.25C3.75 7.83652 4.08652 7.5 4.5 7.5H9.33322V6H4.5C3.25927 6 2.25 7.00927 2.25 8.25V19.5C2.25 20.7407 3.25927 21.75 4.5 21.75H15.75C16.9907 21.75 18 20.7407 18 19.5V14.6668H16.5V19.5Z" fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_685_3072">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function UndockIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_746_11247)">
                <path d="M4.5 21.75H12V20.25H4.81058L14.7803 10.2803L13.7198 9.21968L3.75 19.1894V12H2.25V19.5C2.25 20.7407 3.25928 21.75 4.5 21.75ZM7.5 4.5C7.5 4.08615 7.83615 3.75 8.25 3.75H19.5C19.9135 3.75 20.25 4.08615 20.25 4.5V15.75C20.25 16.1635 19.9135 16.5 19.5 16.5H14.6668V18H19.5C20.7407 18 21.75 16.9907 21.75 15.75V4.5C21.75 3.25928 20.7407 2.25 19.5 2.25H8.25C7.00928 2.25 6 3.25928 6 4.5V9.33322H7.5V4.5Z" fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_746_11247">
                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 -1 24 24)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function CloseIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_685_3071)">
                <path d="M21.75 3.31058L20.6894 2.25L12 10.9394L3.31058 2.25L2.25 3.31058L10.9394 12L2.25 20.6894L3.31058 21.75L12 13.0606L20.6894 21.75L21.75 20.6894L13.0606 12L21.75 3.31058Z" fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_685_3071">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function ArrowDownIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
            <path
                d="M6 8.25L10 12.25L14 8.25"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function RightArrowIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path
                d="M10 4l4 4-4 4m4-4H2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

type IconProps = {
    className?: string;
};

export function ChevronDownIcon({ className }: IconProps) {
    return (
        <svg
            className={className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            aria-hidden="true"
            focusable="false"
        >
            <path
                d="M4 6l4 4 4-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ImageIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
            <rect x="2.5" y="3.5" width="15" height="13" rx="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
            <circle cx="7.5" cy="8" r="1.3" fill="currentColor" />
            <path
                d="M5.2 15L9.1 11.1a1 1 0 0 1 1.4 0l2.6 2.6 1.5-1.5a1 1 0 0 1 1.4 0L18 14.7"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function CameraIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
            <rect x="2" y="5" width="16" height="11" rx="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
            <path
                d="M7 5l1-2h4l1 2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="10" cy="11" r="3" fill="none" stroke="currentColor" strokeWidth="1.4" />
            <circle cx="15.5" cy="7.5" r="0.8" fill="currentColor" />
        </svg>
    );
}

export function AttachmentRemoveIcon() {
    return (
        <svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <g clipPath="url(#clip0_attachment_remove)">
                <path
                    d="M21.75 3.31058L20.6894 2.25L12 10.9394L3.31058 2.25L2.25 3.31058L10.9394 12L2.25 20.6894L3.31058 21.75L12 13.0606L20.6894 21.75L21.75 20.6894L13.0606 12L21.75 3.31058Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_attachment_remove">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function StopIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 44 44" fill="none" aria-hidden="true" focusable="false">
            <rect x="0.25" y="0.25" width="43.5" height="43.5" rx="3.75" fill="#CCDCFF" stroke="#0000FE" strokeWidth="0.5" />
            <rect x="12" y="12" width="20" height="20" rx="2" fill="#0001FE" />
        </svg>
    );
}

export function SendIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 44 44" fill="none" aria-hidden="true" focusable="false">
            <path d="M0 4C0 1.79086 1.79086 0 4 0H40C42.2091 0 44 1.79086 44 4V40C44 42.2091 42.2091 44 40 44H4C1.79086 44 0 42.2091 0 40V4Z" fill="#0000FE" />
            <g clipPath="url(#clip0_send_button)">
                <path
                    d="M25 31.75L31.2614 23.3931C31.9107 22.5735 31.9107 21.4265 31.2735 20.6223L25 12.25L23.7996 13.1494L29.8698 21.25H12.25V22.75H29.8695L23.7996 30.8506L25 31.75Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_send_button">
                    <rect width="24" height="24" fill="white" transform="translate(10 10)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function CopyIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <rect x="5" y="5" width="8" height="8" rx="1.4" ry="1.4" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <path
                d="M4 3h7a1 1 0 0 1 1 1v1"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="3" y="3" width="8" height="8" rx="1.4" ry="1.4" fill="none" stroke="currentColor" strokeWidth="1.2" />
        </svg>
    );
}

export function ThumbUpIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path
                d="M6 7V3.5A 1.5 1.5 0 0 1 7.5 2l1.2 3.4h4.3a1 1 0 0 1 .9 1.4l-1.8 4.6a2 2 0 0 1-1.8 1.2H5.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="2" y="7" width="3" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.2" />
        </svg>
    );
}

export function ThumbDownIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path
                d="M10 9v3.5A 1.5 1.5 0 0 1 8.5 14l-1.2-3.4H3a1 1 0 0 1-.9-1.4l1.8-4.6A 2 2 0 0 1 5.7 3h4.8"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="11" y="3" width="3" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.2" />
        </svg>
    );
}

export function RefreshIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path
                d="M3.5 7a4.5 4.5 0 0 1 7.6 -2.4L12.5 6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 9a4.5 4.5 0 0 1 -7.6 2.4L3.5 10"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 4.5h2v2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 11.5H3v-2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function DotsIcon() {
    return (
        <svg width="16" height="4" viewBox="0 0 16 4" aria-hidden="true" focusable="false">
            <circle cx="2" cy="2" r="1.2" fill="currentColor" />
            <circle cx="8" cy="2" r="1.2" fill="currentColor" />
            <circle cx="14" cy="2" r="1.2" fill="currentColor" />
        </svg>
    );
}

export function PlusIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_685_3064)">
                <path d="M18.125 9.375H10.625V1.875H9.375V9.375H1.875V10.625H9.375V18.125H10.625V10.625H18.125V9.375Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_685_3064">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function ChevronIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false">
            <path
                d="M4 6l3 3 3-3"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function MicIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <rect x="6" y="3" width="4" height="7" rx="2" fill="none" stroke="currentColor" strokeWidth="1.2" />
            <path
                d="M4 7.5V8a4 4 0 0 0 8 0v-.5M8 12v2m-2.5 0h5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
        </svg>
    );
}

export function ResetIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_754_11291)">
                <path d="M18.125 16.875H10V18.125H18.125V16.875Z" fill="black" />
                <path d="M5.86306 18.125H1.875V14.1369L13.5882 2.406C14.2962 1.698 15.5377 1.698 16.2458 2.406L17.5763 3.73625C17.9303 4.09025 18.125 4.56206 18.125 5.065C18.125 5.56794 17.9303 6.03975 17.5763 6.39375L5.86306 18.125ZM3.125 16.875H5.34544L16.6925 5.50994C16.8103 5.39212 16.875 5.23406 16.875 5.065C16.875 4.89594 16.8103 4.73787 16.6925 4.62006L15.3619 3.28981C15.1263 3.05362 14.7076 3.05362 14.4721 3.28981L3.125 14.6546V16.875Z" fill="black" />
            </g>
            <defs>
                <clipPath id="clip0_754_11291">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
}

export function DebugJsonCopyIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2.984V2h-.09c-.313 0-.616.062-.909.185a2.33 2.33 0 0 0-.775.53 2.23 2.23 0 0 0-.493.753v.001a3.542 3.542 0 0 0-.198.83v.002a6.08 6.08 0 0 0-.024.863c.012.29.018.58.018.869 0 .203-.04.393-.117.572v.001a1.504 1.504 0 0 1-.765.787 1.376 1.376 0 0 1-.558.115H2v.984h.09c.195 0 .38.04.556.121l.001.001c.178.078.329.184.455.318l.002.002c.13.13.233.285.307.465l.001.002c.078.18.117.368.117.566 0 .29-.006.58-.018.869-.012.296-.004.585.024.87v.001c.033.283.099.558.197.824v.001c.106.273.271.524.494.753.223.23.482.407.775.53.293.123.596.185.91.185H6v-.984h-.09c-.2 0-.387-.038-.563-.115a1.613 1.613 0 0 1-.457-.32 1.659 1.659 0 0 1-.309-.467c-.074-.18-.11-.37-.11-.573 0-.228.003-.453.011-.672.008-.228.008-.45 0-.665a4.639 4.639 0 0 0-.055-.64 2.682 2.682 0 0 0-.168-.609A2.284 2.284 0 0 0 3.522 8a2.284 2.284 0 0 0 .738-.955c.08-.192.135-.393.168-.602.033-.21.051-.423.055-.64.008-.22.008-.442 0-.666-.008-.224-.012-.45-.012-.678a1.47 1.47 0 0 1 .877-1.354 1.33 1.33 0 0 1 .563-.121H6zm4 10.032V14h.09c.313 0 .616-.062.909-.185.293-.123.552-.3.775-.53.223-.23.388-.48.493-.753v-.001c.1-.266.165-.543.198-.83v-.002c.028-.28.036-.567.024-.863-.012-.29-.018-.58-.018-.869 0-.203.04-.393.117-.572v-.001a1.502 1.502 0 0 1 .765-.787 1.38 1.38 0 0 1 .558-.115H14v-.984h-.09c-.196 0-.381-.04-.557-.121l-.001-.001a1.376 1.376 0 0 1-.455-.318l-.002-.002a1.415 1.415 0 0 1-.307-.465v-.002a1.405 1.405 0 0 1-.118-.566c0-.29.006-.58.018-.869a6.174 6.174 0 0 0-.024-.87v-.001a3.537 3.537 0 0 0-.197-.824v-.001a2.23 2.23 0 0 0-.494-.753 2.331 2.331 0 0 0-.775-.53 2.325 2.325 0 0 0-.91-.185H10v.984h.09c.2 0 .387.038.562.115.174.082.326.188.457.32.127.134.23.29.309.467.074.18.11.37.11.573 0 .228-.003.452-.011.672-.008.228-.008.45 0 .665.004.222.022.435.055.64.033.214.089.416.168.609a2.285 2.285 0 0 0 .738.955 2.285 2.285 0 0 0-.738.955 2.689 2.689 0 0 0-.168.602c-.033.21-.051.423-.055.64a9.15 9.15 0 0 0 0 .666c.008.224.012.45.012.678a1.471 1.471 0 0 1-.877 1.354 1.33 1.33 0 0 1-.563.121H10z"
                fill="currentColor"
            />
        </svg>
    );
}
